import { StandardEvents } from '@shopify/events';

// Horizon's cart icon counts every line, add-ons included. After each cart update,
// re-render the bubble with the number of things being made (add-on lines excluded).
const madeCount = (cart) =>
  cart.items.reduce((sum, item) => (item.product_type === 'Add-on' ? sum : sum + item.quantity), 0);

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(() => fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }))
    .then((response) => response.json())
    .then((cart) => {
      for (const icon of document.querySelectorAll('cart-icon')) {
        /** @type {any} */ (icon).renderCartBubble?.(madeCount(cart), false);
      }
    })
    .catch(() => {});
});
